export const iconFontAwesomeEducationChalkboardUser = (
	<i className="fa-solid fa-chalkboard-user"></i>
);
